import {
  NIPT_NETWORK_RESPONSE,
  NIPT_NETWORK_FAILURE,
  NIPT_NETWORK_REQUEST,
  NIPT_NETWORK_SELECT_EXPERTS
} from "../../actions/types";

const defaultKeywords = `NON-INVASIVE PRENATAL TESTING`;

const initialState = {
  isFetching: false,
  isMoreResult: true,
  isMoreResultLoading: false,
  nodes: [],
  edges: {},
  keywordCloud: [],
  locationCloud: [],
  selectedNodes: [],
  error: false,
  isInitialScreen: true,
  keyword: "",
  size: 10,
  from: 0,
  activePage: 1,
  totalExperts: 0,
  terms: defaultKeywords,
  country: "",
  experts: [],
  university: [],
  activeSortItem: {
    value: "term_citation_count",
    label: "Total Related Citation"
  },
  year: ""
};

const updateSelectedNodes = (state, action) => {
  const { selectedNodes } = action.payload;
  return {
    ...state,
    selectedNodes: selectedNodes || []
  };
};

const setRequest = (state, action) => {
  const {
    terms = "",
    country = "",
    experts = [],
    university = [],
    size = 10,
    selectedNodes = [],
    year= ""
  } = action.payload;

  let keyword = terms.split(",");
  keyword = keyword.join(", ");

  return {
    ...state,
    isFetching: true,
    error: false,
    isInitialScreen: false,
    nodes: [],
    edges: {},
    keywordCloud: [],
    locationCloud: [],
    experts,
    country,
    terms,
    university,
    year,
    selectedNodes: selectedNodes || [],
    size: size,
    keyword: keyword ? keyword : defaultKeywords
  };
};

const setFailure = (state, action) => {
  return {
    ...state,
    isFetching: false,
    error: true,
    isInitialScreen: false,
    node_output: [],
    edges_output: [],
    keyword: "",
    totalExperts: 0,
    activeSortItem: {
      value: "term_citation_count",
      label: "Total Related Citation"
    },
    terms: "",
    country: "",
    experts: [],
    university: [],
    selectedNodes: [],
    size: 10
  };
};

const setResponse = (state, action) => {
  let { totalExperts = "-", activePage, activeSortItem } = action.payload;
  let nodes = action.payload.node_output || [];
  let edges = action.payload.edges_output || {};
  let keywordCloud = action.payload.keyword_cloud || [];
  let locationCloud = action.payload.location_cloud || [];
  return {
    ...state,
    isFetching: false,
    error: false,
    nodes,
    edges,
    keywordCloud,
    locationCloud,
    isInitialScreen: false,
    totalExperts,
    activePage,
    activeSortItem
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case NIPT_NETWORK_RESPONSE:
      return setResponse(state, action);
      break;

    case NIPT_NETWORK_FAILURE:
      return setFailure(state, action);
      break;

    case NIPT_NETWORK_REQUEST:
      return setRequest(state, action);

    case NIPT_NETWORK_SELECT_EXPERTS:
      return updateSelectedNodes(state, action);

    default:
      return state;
      break;
  }
};
